import vSelect from 'vue-select';

vSelect.props.components.default = function setVueSelectChildComponents() {
  return {
    Deselect: {
      render: function renderVueSelectDeselectComponent(createElement) {
        return createElement('a', null, [
          createElement('i', {
            class: 'glyphicon glyphicon-remove'
          })
        ]);
      }
    },
    OpenIndicator: {
      render: function renderVueSelectOpenIndicatorComponent(createElement) {
        return createElement('i', {
          class: 'caret'
        });
      }
    }
  };
};
